var url = 'https://github-search-backend.vercel.app/users/'

export function getUser(username) {
  return fetch(url+username).then((data) =>
    data.json()
  );
}

export function getFollowers(username) {
  return fetch(url+username+"/followers").then((data) =>
    data.json()
  );
}

export function getFollowing(username) {
  return fetch(url+username+"/following").then((data) =>
    data.json()
  );
}

export function getRepos(username) {
  return fetch(url+username+'/repos').then((data) =>
    data.json()
  );
}

export function getGists(username) {
  return fetch(url+username+'/gists').then((data) =>
    data.json()
  );
}

export const getRandomUser = async () => {
  const res = await fetch(url+'get/random');
  return res.json();
}
